import React from "react";

const UniversalBanner = (props) => {
    return(
        <>
            <section className="banner-universal">
                <div className="container">
                    <div className="universal-banner-start">
                        <h1 className="sm-heading">{props.heading}</h1>
                    </div>
                </div>
            </section>
        </>
    )
}
export default UniversalBanner;